export * from './Button';



// WEBPACK FOOTER //
// ./src/components/Common/Button/index.ts